<template>
  <div class="resources-categories">
    <ul class="resources-categories-list" v-if="filteredCategories.length">
      <li
        class="resources-category"
        v-for="category in filteredCategories"
        :key="category.name"
      >
        <divider class="primary-divider" orientation="left">{{ category.title }}</divider>
        <resources-list :resources="getCategoryResources(category.name)" />
      </li>
    </ul>
    <div v-else class="ms-nodata ms-text">Материалы отсутствуют</div>
  </div>
</template>

<script>
import ResourcesList from './resources-list'

const categories = [
  {
    name: 'contracts',
    title: 'Основные документы'
  },
  {
    name: 'acts',
    title: 'Акты'
  },
  {
    name: 'payments',
    title: 'Платежи'
  },
  {
    name: 'law_cases',
    title: 'Судебные дела'
  },
  {
    name: 'procedures',
    title: 'Запросы материалов'
  },
  {
    name: 'bank_guarantee_versions',
    title: 'Банковские гарантии'
  }
]

export default {
  props: {
    resources: {
      type: Array,
      required: true
    }
  },
  components: {
    ResourcesList
  },
  computed: {
    filteredCategories () {
      return categories.filter(
        ({ name }) =>
          !!this.resources.filter((r) => r.object_type === name).length
      )
    }
  },
  methods: {
    getCategoryResources (name) {
      return this.resources.filter((r) => r.object_type === name)
    }
  }
}
</script>

<style lang="less">
.resources {
  &-categories {
    margin: 0;
    padding: 0;

    &-list {
      list-style-type: none;
    }
  }

  &-category {
    &:not(:first-child) {
      margin-top: 32px;
    }

    &-title {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 1px;
      margin-bottom: 4px;
      text-transform: uppercase;
    }
  }
}
</style>
